import cache_data_siteSetting from "@core/helpers/server/cache-data/siteSetting";

export const get_current_locate_server = async (force = true) => {
	const siteDetail = await cache_data_siteSetting(undefined, force);
	let locale = siteDetail?.current_locale;
	if (!locale || locale === 'null') {
		locale = "fa";
	}
	return locale;
}

export const get_direction_server = async () => {
	const locate = await get_current_locate_server();
	// every right-to-left language, not only the ones listed in locates-direction.json ("rtl" as before when unknown)
	const { get_locale_direction } = require("@core/helpers/locale-rules");
	return get_locale_direction(locate, "rtl")
}

export const get_locates_server = async () => {
	const siteDetail = await cache_data_siteSetting();
	return siteDetail?.all_locales || ["fa"]
}

export const get_default_locate_server = async () => {
	const locates = await get_locates_server();
	return await locates?.[0] || 'fa'
}

export const is_valid_locale_server = async () => {
	const siteDetail = await cache_data_siteSetting();
	// `invalid_locale` is a boolean (siteSetting.js); it was compared with the string "false", so every locale looked invalid
	return siteDetail?.invalid_locale !== true
}